import { render, staticRenderFns } from "./DetailTable.vue?vue&type=template&id=92a7e4ce&scoped=true"
import script from "./DetailTable.vue?vue&type=script&lang=js"
export * from "./DetailTable.vue?vue&type=script&lang=js"
import style0 from "./DetailTable.vue?vue&type=style&index=0&id=92a7e4ce&prod&lang=less&scoped=true"
import style1 from "./DetailTable.vue?vue&type=style&index=1&id=92a7e4ce&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92a7e4ce",
  null
  
)

export default component.exports